"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createApiRoutes = void 0;
var urlcat_1 = __importDefault(require("urlcat"));
function createApiRoutes(baseUrl) {
    function route(path) {
        return function (params) { return (0, urlcat_1.default)(baseUrl, path, params || {}); };
    }
    return {
        archiveFile: route('/:id/archive'),
        commitFileUpload: route('/api/commit-file-upload'),
        generateEmailLoggingAddress: route('/api/generate-email-logging-address'),
        getAssociations: route('/api/associations'),
        getFile: route('/:id'),
        getFileContents: route('/:id/contents'),
        getFiles: route('/api/files'),
        getSignedURL: route('/api/get-signed-url'),
        unarchiveFile: route('/:id/unarchive'),
        updateFile: route('/:id/update'),
    };
}
exports.createApiRoutes = createApiRoutes;
